module.exports = __webpack_public_path__ + "static/media/closedEye.4f1d7afb.png";